export const SALESFORCE_ACCESS_TOKEN_STORAGE_KEY = 'salesforce_access_token';

